;(function() {
  'use strict'

  Controller.$inject = ["userService", "websiteService"];
  angular.module('app.survey').component('surveyQuestionFollowup', {
    controller: Controller,
    templateUrl: 'survey-question-followup.html',
    bindings: {
      survey: '<',
      question: '<',
    },
  })

  /* @ngInject */
  function Controller(userService, websiteService) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.isLoggedIn = userService.loggedIn
    ctrl.checkEmail = checkEmail
    ctrl.login = login
    ctrl.trimTitle = trimTitle
    ctrl.websiteUrl = websiteService.getWebsiteUrl()

    function onInit() {
      if (!ctrl.question.data) {
        ctrl.question.data = {}
        ctrl.question.emailChecker = userService.getEmailChecker()
      }
    }

    function checkEmail() {
      ctrl.question.email = undefined
      ctrl.question.emailChecker
        .check(ctrl.question.data.emailQuery)
        .then(updateEmail)
        .catch(updateEmail)
    }

    function updateEmail() {
      ctrl.question.email =
        ctrl.question.emailChecker.state === 'available'
          ? ctrl.question.data.emailQuery
          : undefined
    }

    function login() {
      userService
        .showLogin(null, { prefillEmail: ctrl.question.data.emailQuery })
        .then(function() {
          ctrl.question.data.emailQuery = undefined
          ctrl.question.email = undefined
        })
    }

    /**
     * trim content within brackets from title
     * @param  {String} title element title
     * @return {String}       element title with content between brackets stripped
     */
    function trimTitle(title) {
      return title ? title.replace(/ *\([^)]*\) */g, '') : 'this business'
    }
  }
})()
